export const transformKwhRank = (value) => {
  return (value / 1000).toFixed(1)
}
